(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["site-map"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const headers = document.querySelectorAll('.sitemap-header');
    headers.forEach(header => {
      header.addEventListener('click', () => {
        const section = header.closest('.sitemap-section');
        section.classList.toggle('active');
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
